import type { AuthSettings } from "@entrilia/shared/auth/authTypes";
import { importEnvVariable } from "@entrilia/shared/variables";

interface EnvVariables {
  MICROSOFT_AUTH_ENDPOINT: string;
  HOST_ENV: string;
  ADMIN_PORTAL_URI: string;
}

let variables: EnvVariables | undefined = undefined;

const importVariables = () => ({
  MICROSOFT_AUTH_ENDPOINT: importEnvVariable("REACT_APP_MICROSOFT_AUTH_ENDPOINT"),
  HOST_ENV: importEnvVariable("REACT_APP_HOST_ENV"),
  ADMIN_PORTAL_URI: importEnvVariable("REACT_APP_ADMIN_PORTAL_URI"),
});

export const getVariables = (): EnvVariables => {
  if (variables === undefined) {
    variables = importVariables();
  }
  return variables;
};

export const importAuthSettings = (): AuthSettings => ({
  authEndpoint: "",
  userFlowSignIn: "",
  userFlowSignUp: "",
  userFlowPasswordReset: "",
  clientId: importEnvVariable("REACT_APP_PORTAL_CLIENT_ID"),
  portalAccessScope: importEnvVariable("REACT_APP_PORTAL_ACCESS_SCOPE"),
  authCookieNames: "x-entrilia-ops-authorized",
  refreshCookieNames: "x-entrilia-ops-refresh-available",
  cookieTarget: "ops",
});
